// extracted by mini-css-extract-plugin
export default {"this":"Title_this__ale6a"};